import { ErrorHandler } from '@angular/core';
import { Injectable } from '@angular/core';
import { NotifierMessageType } from './notifier/notifier.model';
import { NotifierService } from './notifier/notifier.service';

@Injectable()
export class ExceptionHandler extends ErrorHandler {

  constructor(private notifierService: NotifierService) {
    super(true);
  }

  handleError(error: any) {
    // WISH: send the error to an online service for monitoring
    if (error.alreadyShown === undefined) {
      this.notifierService.activateSimple(NotifierMessageType.Error, error.payload && error.payload._body);
    }
    super.handleError(error);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/exception-handler.ts